import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 mt-16">
      <div className="max-w-5xl mx-auto px-5 py-8 text-center">
        <p className="text-xs text-emerald-100/50">© {new Date().getFullYear()} MoYo Stars Date Ltd, London, UK</p>
        <div className="flex items-center justify-center gap-5 mt-3 text-xs">
          <Link to="/terms" data-testid="footer-terms" className="text-emerald-100/60 hover:text-amber-300 transition-colors">Terms of Service</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="text-emerald-100/60 hover:text-amber-300 transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
